/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mHead.vue?vue&type=template&id=72f39c25&scoped=true"
import script from "./mHead.vue?vue&type=script&lang=js"
export * from "./mHead.vue?vue&type=script&lang=js"
import style0 from "./mHead.vue?vue&type=style&index=0&id=72f39c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f39c25",
  null
  
)

export default component.exports